import React from "react";

import { withShowIf } from "../with-show-if/with-show-If.component";

import { ProgressBarBorder, ProgressBarProgress } from "./progress-bar.styles";
import { ProgressBarProps } from "./progress-bar.props";

export const ProgressBar = withShowIf((props: ProgressBarProps) => (
  <ProgressBarBorder>
    <ProgressBarProgress {...props} />
  </ProgressBarBorder>
));
